package com.neurobs.ccabserver.subjectsessionview.components.sessionrunview.components

import com.neurobs.ccab.{LogTestRun, TestRunDetail}
import com.neurobs.ccabserver.subjectsessionview.components.PropertyLabel
import com.neurobs.js.util.StringUtilities.dateTimeString
import com.neurobs.react.ReactUtil
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

@react
object LogTestRunView {
  case class Props(logTestRun: LogTestRun, enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    def startTime = props.logTestRun.startTime
    def error = props.logTestRun.error
    def comments = props.logTestRun.comments.map(_.sortBy(_.time.instant.getEpochSecond).map(_.text)).getOrElse(List())

    def StartTimeElement: ReactElement = PropertyLabel("Start time", dateTimeString(startTime))
    def ErrorElement: ReactElement = error match {
      case None => null
      case Some(errorString) => RunErrorMessage(errorString)
    }
    def CommentsElement: ReactElement = CommentsAccordion(comments)

    props.enclosingElement(
      Seq(
        StartTimeElement,
        ErrorElement,
        CommentsElement
      )
    )
  }
}
